/*
 * @Descripttion: axios 请求拦截、响应拦截、错误统一处理
 * @Define: 定义
 * @Use: 使用
 * @Author: yeming
 * @Date: 2018-06-05 15:51:42
 */

// 注：同步请求 ES7的异步特性async / await
// 注：async 用于申明一个函数是异步的，await等待异步请求完成，await只能在async方法中使用！！！

// async handleInit() {
//   await this.$api.Login.login(param).then(res => {}).catch(err => {});
// }

import axios from 'axios';

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    case 404: // 404请求不存在
      
      break;
    case 500: // 服务器错误
      
      break;
    default:
      // DonMessage.error('未知错误，请重试或联系管理员！');
      // console.log(other);
  }
};

// 创建axios实例
export var instance = axios.create({
  baseURL:'/api',
  timeout: 1000 * 10, // 超时时间
  // retry: 3, // 超时之后自动重新请求次数
  // retryDelay: 1000, // 超时之后自动重新请求间隙
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    'Cache-Control': 'no-cache'
  },
  transformRequest: [function (data) {
    let newData = '';
    for (let k in data) {
      if (data.hasOwnProperty(k) === true) {
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return newData;
  }]
});

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    console.log('请求拦截',config)
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    // const token = store.state.token;
    // token && (config.headers.Authorization = token);
    return config;
  },
  error => Promise.error(error));

/**
 * 响应拦截器
 */
instance.interceptors.response.use(
  // 请求成功
  res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
  // 请求失败
  error => {
    const {
      response
    } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      // 请求超时或断网时，提示操作
      DonMessage.error('请求超时，请重试！');

      // // 请求超时， 重新请求
      // var config = error.config;
      // // If config does not exist or the retry option is not set, reject
      // if (!config || !config.retry) return Promise.reject(error);

      // // Set the variable for keeping track of the retry count
      // config.__retryCount = config.__retryCount || 0;

      // // Check if we've maxed out the total number of retries
      // if (config.__retryCount >= config.retry) {
      //   // Reject with the error
      //   return Promise.reject(error);
      // }

      // // Increase the retry count
      // config.__retryCount += 1;

      // // Create new promise to handle exponential backoff
      // var backoff = new Promise(function (resolve) {
      //   setTimeout(function () {
      //     resolve();
      //   }, config.retryDelay || 1);
      // });

      // // Return the promise in which recalls axios to retry the request
      // return backoff.then(function () {
      //   return instance(config);
      // });
    }
  });

export default instance;



// WEBPACK FOOTER //
// ./src/views/yf/request.js